export enum Teams {
    Boom = 'email_campaigns',
}

export enum Features {
    Subscribers = 'subscribers',
    ManageSubscribers = 'manage_subscribers',
}

export enum Components {
    ImportList = 'import_a_list',
    NewList = 'new_list',
    PreviousEvents = 'previous_events',
    UploadCSV = 'upload_csv',
    ManualAdd = 'manual_add',
    ManualAddSingle = 'manual_add_single',
    ManualAddMultiple = 'manual_add_multiple',
}

export enum Actions {
    Start = 'start',
    ChooseFile = 'choose_file',
    Submit = 'submit',
    Create = 'create',
}
